import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from './store';

export const ProtectedRoute = () => {
  const token = useAuthStore((s) => s.token);
  const location = useLocation();
  if (!token) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  return <Outlet />;
};
